export enum LeaveType {
  PTO = "PTO",
  Vacation = "VACATION",
  Sick = "SICK",
  Bereavement = "BEREAVEMENT"
}